export const REGIONS_ACTIONS = {
  REQUESTED: 'regions/requested',
  SUCCEEDED: 'regions/succeeded',
  FAILED: 'regions/failed',
};

export interface RegionsSucceeded {
  type: string;
  payload: { regions: any[] };
}

export const regionsSucceeded = (regions: any[]): RegionsSucceeded => ({
  type: REGIONS_ACTIONS.SUCCEEDED,
  payload: { regions },
});

export interface RegionsRequested {
  type: string;
}

export const regionsRequested = (): RegionsRequested => ({
  type: REGIONS_ACTIONS.REQUESTED,
});

export interface RegionsFailed {
  type: string;
  error: string;
}

export const regionsFailed = (error: string) => ({
  error,
  type: REGIONS_ACTIONS.FAILED,
});

export type RegionsAction = RegionsRequested | RegionsSucceeded | RegionsFailed;



// WEBPACK FOOTER //
// ./src/scenes/Regions/services/actions.ts